import React, { useState, useEffect } from 'react';
import { Grid, Button, Box, TextField, Drawer } from '@mui/material';
import dayjs from 'dayjs';
// import CountWidget from './count-widget.component';
// import { MonthCalendar } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  getMonthlyActiveUser,
  getMonthlyAdData,
} from '../../../services/reports.service';
import Iconify from '../iconify.component';

import LineChartWidget from './line-charts-widget.component';
import { getCurrentTimezoneOffset } from '../../../utils/datetime.util';
import FilterReports from '../../reports/filter-reports.component';

// import LineChartWidget from './line-charts-widget.component';

const Reports = () => {
  const [selectMonth, setSelecteMonth] = React.useState(dayjs(new Date()));
  const maxDate = dayjs(new Date());
  const [openFilters, setOpenFilters] = useState(false);
  const [activeUserData, setActiveUserData] = useState({
    activeUserDates: [],
    activeMonthlyUser: [],
    activeBrdUser: [],
  });
  const [activeAdData, setActiveAdData] = useState({
    activeAdsDate: [],
    adRequested: [],
    adRequestedFail: [],
    adStart: [],
    adFail: [],
    adComplete: [],
    adStop: [],
  });
  const [options, setOptions] = useState({
    appliedFilters: {
      filterApp: null,
      platforms: [],
    },
    reloadCounter: 0,
    loading: false,
    filtersCounter: 0,
  });

  const getTotalActiveMonthlyData = (res) => {
    const data = { install: [], brd: [] };
    const activeMonthlyUser = [];
    const activeBrdUser = [];
    const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    let timzoneDiff = 0;
    if (timeZoneOffset < 0) {
      timzoneDiff = timeZoneOffset * -1;
    }
    res?.data?.activeUsersData?.forEach((element) => {
      activeMonthlyUser.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.totalActiveUser,
      });
    });
    res?.data?.activeBrdData?.forEach((element) => {
      activeBrdUser.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.totalActiveBrdUser,
      });
    });
    data.install = activeMonthlyUser;
    data.brd = activeBrdUser;
    return data;
  };

  const getTotalActiveAdData = (res) => {
    const data = {
      adRequested: [],
      adRequestedFail: [],
      adStart: [],
      adFail: [],
      adComplete: [],
      adStop: [],
    };
    const adRequested = [];
    const adRequestedFail = [];
    const adStart = [];
    const adFail = [];
    const adComplete = [];
    const adStop = [];
    const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    let timzoneDiff = 0;
    if (timeZoneOffset < 0) {
      timzoneDiff = timeZoneOffset * -1;
    }
    res?.data?.adData?.forEach((element) => {
      adRequested.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adRequested,
      });
      adRequestedFail.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adRequestedFail,
      });
      adStart.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adStart,
      });
      adFail.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adFail,
      });
      adComplete.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adComplete,
      });
      adStop.push({
        x: new Date(new Date(element.date).getTime() + timzoneDiff),
        y: element?.adStop,
      });
    });

    data.adRequested = adRequested;
    data.adRequestedFail = adRequestedFail;
    data.adStart = adStart;
    data.adFail = adFail;
    data.adComplete = adComplete;
    data.adStop = adStop;
    return data;
  };

  const getMonthDate = (res, key) => {
    const dates = [];
    const timeZoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    let timzoneDiff = 0;
    if (timeZoneOffset < 0) {
      timzoneDiff = timeZoneOffset * -1;
    }
    res?.data[key]?.forEach((element) => {
      dates.push(new Date(element.date).getTime() + timzoneDiff);
    });
    return dates;
  };

  const calculateMonthFromCurrentDate = (selectedMonth) => {
    const currentDate = dayjs(new Date());
    const monthDiff = currentDate.diff(selectedMonth, 'month');
    return monthDiff;
  };

  useEffect(() => {
    const params = [];
    params.push(`timezone=${encodeURIComponent(getCurrentTimezoneOffset())}`);
    const month = calculateMonthFromCurrentDate(selectMonth);
    params.push(`month=${month}`);
    const filters = options.appliedFilters;
    if (filters.platforms.length > 0) {
      const platforms = [];
      filters.platforms.forEach((p) => platforms.push(p.id));
      params.push(`platforms=${platforms.join(',')}`);
    }
    if (filters.filterApp && filters.filterApp.id) {
      params.push(`appId=${encodeURIComponent(filters.filterApp.id)}`);
    }
    const paramsQuery = params.length > 0 ? `?${params.join('&')}` : '';
    getMonthlyActiveUser(paramsQuery)
      .then((res) => {
        const activeMonthlyUserData = getTotalActiveMonthlyData(res);

        setActiveUserData({
          ...activeUserData,
          activeMonthlyUser: activeMonthlyUserData.install,
          activeBrdUser: activeMonthlyUserData.brd,
          activeUserDates: getMonthDate(res, 'activeUsersData'),
        });
      })
      .catch(() => {
        // ignore
      });
    getMonthlyAdData(paramsQuery)
      .then((res) => {
        const activeMonthlyAdData = getTotalActiveAdData(res);
        setActiveAdData({
          ...activeAdData,
          adRequested: activeMonthlyAdData.adRequested,
          adRequestedFail: activeMonthlyAdData.adRequestedFail,
          adStart: activeMonthlyAdData.adStart,
          adFail: activeMonthlyAdData.adFail,
          adComplete: activeMonthlyAdData.adComplete,
          adStop: activeMonthlyAdData.adStop,
          activeAdsDate: getMonthDate(res, 'adData'),
        });
      })
      .catch(() => {
        // ignore
      });
  }, [options.reloadCounter, selectMonth]);

  const handleRefresh = () => {
    setOptions({
      ...options,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  const handleToggleFilters = () => {
    setOpenFilters(!openFilters);
  };
  const handleApplyFilters = (selectedFilters) => {
    let counter = 0;
    if (selectedFilters.filterApp) counter += 1;
    if (selectedFilters.platforms.length > 0) counter += 1;
    setOptions({
      ...options,
      appliedFilters: {
        ...selectedFilters,
      },
      filtersCounter: counter,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
    handleToggleFilters();
  };
  const handleClearFilters = () => {
    handleToggleFilters();
    setOptions({
      ...options,
      appliedFilters: {
        filterApp: null,
        platforms: [],
      },
      filtersCounter: 0,
      reloadCounter: options.reloadCounter + 1,
      loading: true,
    });
  };

  return (
    <div>
      <Grid container>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingY="16px"
          width="100%"
        >
          <Grid container xs justifyContent="flex-end">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {/* <Typography>
                Selected: {selectedMonth.format('MMMM YYYY')}
              </Typography> */}
              <DatePicker
                views={['month', 'year']}
                label="Select Month"
                minDate={dayjs('2025-01-01')}
                maxDate={maxDate}
                value={selectMonth}
                sx={{ marginRight: 2 }}
                onChange={(newValue) => setSelecteMonth(newValue)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <Button
              color={options.filtersCounter > 0 ? 'warning' : 'inherit'}
              variant="contained"
              startIcon={<Iconify icon="ic:round-filter-list" />}
              sx={{ marginRight: 2 }}
              onClick={handleToggleFilters}
            >
              Filters
              {options.filtersCounter > 0 ? ` (${options.filtersCounter})` : ''}
            </Button>
            <Button
              color="inherit"
              variant="contained"
              startIcon={<Iconify icon="mdi:refresh" />}
              sx={{ marginRight: 2, justifyContent: 'flex-end' }}
              onClick={handleRefresh}
            >
              Refresh
            </Button>
          </Grid>
        </Box>
        <Drawer
          anchor="right"
          open={openFilters}
          onClose={handleToggleFilters}
          PaperProps={{
            sx: { width: 300, border: 'none', overflow: 'hidden' },
          }}
        >
          <FilterReports
            values={options.appliedFilters}
            onCancel={handleToggleFilters}
            onSuccess={handleApplyFilters}
            onClear={handleClearFilters}
          />
        </Drawer>
        <Grid container columnSpacing={6} rowSpacing={12} mb={12}>
          <Grid item xs={12} sm={12} md={12}>
            <LineChartWidget
              title="Monthly Report"
              colors={['#4CAF50', '#FF9800']}
              xaxisOption={activeUserData.activeUserDates}
              chartSeries={[
                {
                  name: 'Total Active Users',
                  type: 'line',
                  data: activeUserData.activeMonthlyUser,
                },
                {
                  name: 'Brd Active Users',
                  type: 'line',
                  data: activeUserData.activeBrdUser,
                },
              ]}
              sx={{ height: '100%', width: '100%' }}
            />
          </Grid>
        </Grid>

        <Grid container columnSpacing={6} rowSpacing={12} mb={12}>
          <Grid item xs={12} sm={12} md={12}>
            <LineChartWidget
              title="Monthly Ad Report"
              xaxisOption={activeAdData.activeAdsDate}
              colors={[
                '#FF5733',
                '#33FF57',
                '#3357FF',
                '#F1C40F',
                '#8E44AD',
                '#E74C3C',
              ]}
              chartSeries={[
                {
                  name: 'Total AD Requested',
                  type: 'line',
                  data: activeAdData.adRequested,
                },
                {
                  name: 'Total AD Requested Fail',
                  type: 'line',
                  data: activeAdData.adRequestedFail,
                },
                {
                  name: 'Total AD Start',
                  type: 'line',
                  data: activeAdData.adStart,
                },
                {
                  name: 'Total AD Fail',
                  type: 'line',
                  data: activeAdData.adFail,
                },
                {
                  name: 'Total AD Complete',
                  type: 'line',
                  data: activeAdData.adComplete,
                },
                {
                  name: 'Total AD Stop',
                  type: 'line',
                  data: activeAdData.adStop,
                },
              ]}
              sx={{ height: '100%', width: '100%' }}
            />
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default Reports;
